import type { MoveAction, RunHorsesAction, RunHorsesState } from "../types";
import { applyMoveOnBoard, checkWinner, getOpponentPlayerId } from "../utils";

export function applyMove(
  state: RunHorsesState,
  action: MoveAction,
): RunHorsesState {
  const board = applyMoveOnBoard(state.board, action);
  const winnerId = checkWinner(board);

  return {
    ...state,
    board,
    moveNumber: state.moveNumber + 1,
    lastAction: action,
    phase: winnerId ? "game-over" : "playing",
    winnerId,
    currentPlayerId: winnerId
      ? action.playerId
      : getOpponentPlayerId(action.playerId),
  };
}

export function applyAction(
  state: RunHorsesState,
  action: RunHorsesAction,
): RunHorsesState {
  switch (action.type) {
    case "Move":
      return applyMove(state, action);
  }
}
